import {getAppSessionCookieHeader} from "../appCookie";
import api from "../../Api";

export const getInventoryTypes = async (cafe) => {
  return await api.get('inventory/types' + (cafe ? '/cafe' : '') + getAppSessionCookieHeader()).then((response) => {
    return response.data?.sort((a, b) => a.sortOrder - b.sortOrder);
  });
}

export const getPerkInventoryTypes = async () => {
  return await api.get('inventory/perk/types' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getBrands = async () => {
  return await api.get('inventory/brands' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}


export const searchAllInventory = async (request) => {
  return await api.post('inventory/all' + getAppSessionCookieHeader(), request).then((response) => {
    return response.data;
  });
}

export const getAccountTypes = async () => {
  return await api.get('inventory/account/types' + getAppSessionCookieHeader()).then((response) => {
    return response.data?.sort((a, b) => a.sortOrder - b.sortOrder);
  });
}

export const getInventoryByType = async (type) => {
  return await api.get('inventory/type/' + type + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getEventLocations = async () => {
  return await api.get('inventory/location/types' + getAppSessionCookieHeader()).then((response) => {
    return response.data?.sort((a, b) => a.sortOrder - b.sortOrder);
  });
}

export const getCompanyEventMatrixes = async () => {
  return await api.get('company/matrix/get' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}


export const getInventoryEventPackages = async () => {
  return await api.get('inventory/eventPackages' + getAppSessionCookieHeader()).then((response) => {
    return response.data?.sort((a, b) => a.sortOrder - b.sortOrder);
  });
}

export const getEventPackageInventories = async () => {
  return await api.get('inventory/eventPackage/inventories' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getInventoryEventTypes = async () => {
  return await api.get('inventory/event/types' + getAppSessionCookieHeader()).then((response) => {
    return response.data?.sort((a, b) => a.sortOrder - b.sortOrder);
  });
}

export const getAccountTypeEventTypes = async () => {
  return await api.get('inventory/event/account/types' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getTaskLists = async () => {
  return await api.get('company/tasklists' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const generateTaskLists = async () => {
  return await api.post('company/tasks/generate' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const saveTaskList = async (taskList) => {
  return await api.post('company/tasklist/save' + getAppSessionCookieHeader(), taskList).then((response) => {
    return response.data;
  });
}

export const getAgeRangeTypes = async () => {
  return await api.get('inventory/age/types' + getAppSessionCookieHeader()).then((response) => {
    return response.data?.sort((a, b) => a.sortOrder - b.sortOrder);
  });
}

export const getTipTypes = async () => {
  return await api.get('inventory/tip/types' + getAppSessionCookieHeader()).then((response) => {
    return response.data?.sort((a, b) => a.sortOrder - b.sortOrder);
  });
}

export const saveCashDrawer = async (drawer) => {
  const resp = await api.post('register/drawer' + getAppSessionCookieHeader(), drawer)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const getCashDrawers = async () => {
  return await api.get('register/drawers' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const saveCashEntry = async (entry) => {
  return await api.post('register/entry' + getAppSessionCookieHeader(), entry).then((response) => {
    return response.data;
  });
}

export const getPreviousCashEntry = async (registerGuid) => {
  return await api.get('register/drawer/previous/' + registerGuid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getReferralTypes = async () => {
  return await api.get('inventory/referral/types' + getAppSessionCookieHeader()).then((response) => {
    return response.data?.sort((a, b) => a.sortOrder - b.sortOrder);
  });
}

export const deleteEventCategory = async (guid) => {
  return await api.post('inventory/event/type/delete/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const deleteInventoryType = async (guid) => {
  return await api.post('inventory/type/delete/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const deleteCompanyTaskTemoplate = async (guid) => {
  return await api.post('company/task/template/delete/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const deleteAccountType = async (guid) => {
  return await api.post('inventory/account/type/delete/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const deleteLocation = async (guid) => {
  return await api.post('inventory/location/delete/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const deleteEventPackage = async (guid) => {
  return await api.post('inventory/eventPackage/delete/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const deleteAgeType = async (guid) => {
  return await api.post('inventory/age/delete/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const deleteTipType = async (guid) => {
  return await api.post('inventory/tip/delete/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const deleteRegister = async (guid) => {
  return await api.post('register/archive/drawer/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const deleteReferralType = async (guid) => {
  return await api.post('inventory/referral/delete/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const deleteInventory = async (guid) => {
  return await api.post('inventory/delete/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getInventoryFull = async (cafe) => {
  return await api.get('inventory/full' + (cafe ? '/cafe' : '') + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}


export const getInventory = async (cafeMode) => {
  return await api.get('inventory' + (cafeMode ? '/cafe' : '') + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getInventoryAddOns = async () => {
  return await api.get('inventory/addOns' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getInventoryGiftCards = async () => {
  return await api.get('inventory/giftCards' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getInventoryWaivers = async (categoryId) => {
  return await api.get('inventory/waivers' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getInventoryByCategory = async (categoryId) => {
  return await api.get('inventory/category/' + categoryId + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getInventoryMemberships = async () => {
  return await api.get('inventory/memberships' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const assignMemberPerk = async (perk, client) => {
  return await api.post('perk/assign/' + client?.guid + getAppSessionCookieHeader(), perk).then((response) => {
    return response.data;
  });
}

export const saveMemberPerk = async (perk) => {
  return await api.post('perk/save' + getAppSessionCookieHeader(), perk).then((response) => {
    return response.data;
  });
}

export const archiveMemberPerk = async (perk) => {
  return await api.post('perk/archive' + getAppSessionCookieHeader(), perk).then((response) => {
    return response.data;
  });
}


export const getMemberPerks = async () => {
  return await api.get('perk/perks' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}


export const getMemberPerkTypes = async () => {
  return await api.get('perk/types' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getPerkRecurrenceTypes = async () => {
  return await api.get('perk/recurrence' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}


export const getInventoryEvent = async (guid) => {
  return await api.get('inventory/event/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const removeTag = async (tag) => {
  return await api.post('inventory/tag/remove' + getAppSessionCookieHeader(), tag).then((response) => {
    return response.data;
  });
}

export const saveTag = async (tag) => {
  return await api.post('inventory/tag' + getAppSessionCookieHeader(), tag).then((response) => {
    return response.data;
  });
}

export const getInventoryItem = async (guid) => {
  return await api.get('inventory/item/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getEventReservations = async (guid, future) => {
  return await api.get('inventory/event/reservations/' + guid + (future ? '/future' : '') + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getInventoryEventFull = async (guid) => {
  return await api.get('inventory/event/full/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getInventoryEvents = async (req, inventoryRender) => {
  const resp = await api.post('inventory/events' + getAppSessionCookieHeader(), req).then((response) => {
    let _resp = {inventoryRender: inventoryRender, events: response.data}
    return _resp;
  });
  return resp;
}

export const getDashboardEvents = async (req, inventoryRender) => {
  const resp = await api.post('inventory/dashboard/events' + getAppSessionCookieHeader(), req).then((response) => {
    let _resp = {inventoryRender: inventoryRender, events: response.data}
    return _resp;
  });
  return resp;
}

export const getClientInventoryEvents = async (req, client, inventoryRender) => {
  const resp = await api.post('inventory/events/' + client.guid + getAppSessionCookieHeader(), req).then((response) => {
    let _resp = {inventoryRender: inventoryRender, events: response.data}
    return _resp;
  });
  return resp;
}

export const saveCustomerInventoryEventRegistration = async (reservation, guid) => {
  return await api.post('inventory/waitlist/register' + getAppSessionCookieHeader(), reservation).then((response) => {
    return response.data;
  });
}

export const saveInventoryCategorySortOrders = async (sortRequest) => {
  const resp = await api.post('inventory/event/type/sort' + getAppSessionCookieHeader(), sortRequest)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const saveInventoryTypeSortOrders = async (sortRequest) => {
  const resp = await api.post('inventory/type/sort' + getAppSessionCookieHeader(), sortRequest)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const saveAgeTypeSortOrders = async (sortRequest) => {
  const resp = await api.post('inventory/age/type/sort' + getAppSessionCookieHeader(), sortRequest)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const saveReferralTypeSortOrders = async (sortRequest) => {
  const resp = await api.post('inventory/referral/type/sort' + getAppSessionCookieHeader(), sortRequest)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const saveLocationSortOrders = async (sortRequest) => {
  const resp = await api.post('inventory/location/sort' + getAppSessionCookieHeader(), sortRequest)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const saveAccountTypeSortOrders = async (sortRequest) => {
  const resp = await api.post('inventory/account/type/sort' + getAppSessionCookieHeader(), sortRequest)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}


export const saveInventoryType = async (inventoryType) => {
  const resp = await api.post('inventory/type' + getAppSessionCookieHeader(), inventoryType)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const saveInventoryEventGuests = async (req) => {
  const resp = await api.post('inventory/event/guests' + getAppSessionCookieHeader(), req)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const removeInventoryEventGuest = async (req) => {
  const resp = await api.post('inventory/remove/guest' + getAppSessionCookieHeader(), req)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const saveAgeRangeType = async (ageType) => {
  const resp = await api.post('inventory/age/type' + getAppSessionCookieHeader(), ageType)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const saveTipType = async (tipType) => {
  const resp = await api.post('inventory/tip/type' + getAppSessionCookieHeader(), tipType)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}


export const saveReferralType = async (type) => {
  const resp = await api.post('inventory/referral/type' + getAppSessionCookieHeader(), type)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const saveBrand = async (brand) => {
  const resp = await api.post('inventory/brand' + getAppSessionCookieHeader(), brand)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const saveInventoryEventPackage = async (eventPackage) => {
  const resp = await api.post('inventory/eventPackage' + getAppSessionCookieHeader(), eventPackage)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const saveInventoryEventType = async (inventoryType) => {
  const resp = await api.post('inventory/event/type' + getAppSessionCookieHeader(), inventoryType)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const saveAccountType = async (accountType) => {
  const resp = await api.post('inventory/accountType' + getAppSessionCookieHeader(), accountType)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const saveEventLocation = async (location) => {
  const resp = await api.post('inventory/location' + getAppSessionCookieHeader(), location)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const saveMassInventory = async (req) => {
  const resp = await api.post('inventory/mass/event' + getAppSessionCookieHeader(), req)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const saveInventory = async (inventory) => {
  const resp = await api.post('inventory' + getAppSessionCookieHeader(), inventory)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const preSaveInventoryEvent = async (inventory) => {
  const resp = await api.post('inventory/event/before/save' + getAppSessionCookieHeader(), inventory)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const saveInventoryEvent = async (inventory) => {
  const resp = await api.post('inventory/event' + getAppSessionCookieHeader(), inventory)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const cancelInventoryEvent = async (inventory) => {
  const resp = await api.post('inventory/event/cancel/' + inventory.guid + getAppSessionCookieHeader())
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const cancelInventoryEventAll = async (inventory) => {
  const resp = await api.post('inventory/event/cancel/all/' + inventory.guid + getAppSessionCookieHeader())
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const cancelInventoryEventAllFuture = async (inventory) => {
  const resp = await api.post('inventory/event/cancel/future/' + inventory.guid + getAppSessionCookieHeader())
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}


export const saveInventoryMembership = async (inventory) => {
  const resp = await api.post('inventory/membership' + getAppSessionCookieHeader(), inventory)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

function handleError(error) {
  let err = {
    error: true,
    message: error.response.data.message
  }
  return err;
};
